import * as React from "react";
import { analyticsTracker, classNames } from "../uitk-react-utils/index.js";
import { UitkLinkAligns, UitkLinkSizes, UitkLinkThemes } from "./types.js";
export function UitkLink(props) {
  const align = props.align ?? UitkLinkAligns.get("left");
  const inline = props.inline ?? false;
  const noWrap = props.noWrap ?? false;
  const size = props.size ?? UitkLinkSizes.get("medium");
  const theme = props.theme ?? UitkLinkThemes.get("default");
  const childrenArray = React.Children.toArray(props.children);
  const firstChild = childrenArray[0];
  const childClassName = classNames(
    "uitk-link",
    props.className,
    firstChild.props.className,
    `uitk-link-${size}`,
    {
      [`uitk-link-align-${align}`]: align,
      ["uitk-link-theme-inverse"]: theme === "inverse",
      ["uitk-link-no-wrap"]: noWrap,
      ["uitk-link-layout-inline"]: inline,
      ["uitk-link-layout-default"]: !inline,
      ["uitk-link-disabled"]: !!props.disabled
    }
  );
  const linkChildren = firstChild.props.children;
  const linkIconClassName = classNames(
    `uitk-link-icon-${size}`,
    {
      ["uitk-link-inverse-icon"]: theme === "inverse"
    }
  );
  const disabledButton = props.disabled && firstChild?.type === "button";
  const newChildren = React.Children.map(linkChildren, (child, index) => {
    if (child?.type?.displayName === "UitkIcon") {
      return React.cloneElement(child, {
        key: index,
        className: linkIconClassName
      });
    } else {
      return child;
    }
  });
  function onClick(e) {
    if (props.analytics) {
      analyticsTracker(props.analytics);
    }
    props.onClick?.(e);
    if (firstChild.props.onClick) {
      firstChild.props.onClick(e);
    }
  }
  const newProps = {
    ...props,
    //pass through other props. This should be removed in the future but it is used currently in tests
    analytics: props.analytics,
    className: childClassName,
    align: props.align,
    id: props.id,
    theme: props.theme,
    size: props.size,
    inline: props.inline,
    noWrap: props.noWrap,
    disabled: props.disabled,
    style: { ...props.style, ...firstChild.props.style },
    ...disabledButton && {
      tabIndex: -1,
      disabled: true
    }
  };
  if (props.analytics || props.onClick) {
    newProps.onClick = onClick;
  }
  const decoratedChild = React.cloneElement(firstChild, newProps, newChildren);
  return decoratedChild;
}
UitkLink.displayName = "UitkLink";
